import { render, staticRenderFns } from "./SignUpStepDocumentFail.vue?vue&type=template&id=e073991e"
var script = {}
import style0 from "./SignUpStepDocumentFail.vue?vue&type=style&index=0&id=e073991e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports